import { useState } from "react";
import Drawer from "@mui/material/Drawer";
import TextField from "@mui/material/TextField";
import { RepresentationCard } from "../RepresentationCard";
import { IChart, IRepresentationWidget } from "../../../../@types/chart.type";
import iconClose from "./../../../../assets/icon-closeModal.svg";
import styles from "./styles.module.scss";

interface SidePanelProps {
  open: boolean;
  toggleDrawer: (value: boolean) => void;
  setChartSelected: (value: React.SetStateAction<IChart>) => void;
  listRepresentationCharts: IRepresentationWidget[];
}

export function SidePanel({
  open,
  setChartSelected,
  toggleDrawer,
  listRepresentationCharts,
}: SidePanelProps) {
  const [filterRepresentationCard, setFilterRepresentationCard] = useState("");

  return (
    <Drawer anchor="right" open={open} onClose={() => toggleDrawer(false)}>
      <div className={styles.panel}>
        <div className={styles.headerPanel}>
          <button onClick={() => toggleDrawer(false)}>
            <img src={iconClose} alt="" />
          </button>
          <h3>Adicionar gráfico</h3>
          <p>Personalize sua página, arraste o gráfico para o layout.</p>
          <div className={styles.search}>
            <TextField
              fullWidth
              size="small"
              placeholder="Buscar"
              value={filterRepresentationCard}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                setFilterRepresentationCard(event.target.value)
              }
            />
          </div>
        </div>

        <div className={styles.bodyPanel}>
          {listRepresentationCharts
            .filter((chart) => {
              const match = chart.widgetName
                .toLowerCase()
                .includes(filterRepresentationCard.toLowerCase());

              return match;
            })
            .map((chart) => {
              return (
                <div
                  key={chart.widgetId}
                  draggable={true}
                  unselectable="on"
                  onDragStart={() => {
                    setChartSelected(chart);
                  }}
                >
                  <RepresentationCard
                    name={chart.widgetName}
                    sizeInLayout={chart.size}
                    type={chart.type}
                    description={chart.description}
                  />
                </div>
              );
            })}
        </div>
      </div>
    </Drawer>
  );
}
